import { useSelector, useDispatch } from "react-redux";
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { setModalProperties } from "../../store/actions/userActions";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SnackbarNotification() {
  const dispatch = useDispatch();
//   const { showModal, modalMessage } = useSelector((state) => state.user.modalProperties);
  const modalData= useSelector((state) => state.user?.modalProperties);
console.log("modalData",modalData)
  const handleClose = () => {
    dispatch(setModalProperties({ showModal: false, modalMessage: "" }));
  };

  return (
    <Snackbar
      open={modalData?.showModal}
      autoHideDuration={3000}
      onClose={()=>handleClose()}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
        {modalData?.modalMessage}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarNotification;
